module.exports = __webpack_public_path__ + "static/media/Scroll.21fdf2a3.svg";